/**
 * Bill of Lading API
 *
 * Functions for Bill of Lading CRUD operations.
 * All operations are scoped to the authenticated user's company.
 */

import api from './index';

export const listBillsOfLading = (params = {}) => {
  return api.get('/bills-of-lading', { params });
};

export const getBillOfLading = (id) => {
  return api.get(`/bills-of-lading/${id}`);
};

export const createBillOfLading = (data) => {
  return api.post('/bills-of-lading', data);
};

export const updateBillOfLading = (id, data) => {
  return api.put(`/bills-of-lading/${id}`, data);
};

export const updateDocumentStatus = (id, status) => {
  return api.patch(`/bills-of-lading/${id}/status`, { status });
};

export const deleteBillOfLading = (id) => {
  return api.delete(`/bills-of-lading/${id}`);
};

export const getStats = (params = {}) => {
  return api.get('/bills-of-lading/stats', { params });
};

export const getCarriers = () => {
  return api.get('/bills-of-lading/carriers');
};
